// BanksTable.jsx
import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
//import { BanksColumns, DocumnetsApproversColumns } from "../../../../data/DynamicTable/AccountsColumns";
//import { allBanks, allDocumentApprovers } from "../../../../data/Axios/queries";
import BankForm from "./form";
import DocumentApproversForm from "./form";
import {
  allLeaveTypes,
  allUsers,allDocumentApprovers,
} from "../../../../data/Queries/HRmanagement/leavemanagement";
import { DocumentApproverColumns } from "../../../../data/Columns/SystemSetupColumns";


const base_url = AccountsandFinanceurl.uri;

const actions = {
  entity: "Banks",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
//   viewJournalEntries: { // New action for journal entries
//     key: "VIEW_JOURNAL_ENTRIES",
//     button_name: "View Journal Entries",
//     Show_Button: true,
//     permission: "ViewJournalEntriesPermission",
//     query: "allJournalLinesByColumnValues", // Query to fetch journal entries
//     inputFields: (row) => ({ // Dynamic input fields based on row data
//       accountID: row.id,
//       cancelled: null,
//     }),
//     returnFields: [
//       "journalLineID",
//       "journalEntryID",
//       "accountID",
//       "debit",
//       "credit",
//       "description",
//       "createdDate",
//       "caseId",
//       "applicationId",
//       "applicationType",
//     ],
//   },
  showStatus: true,
};

function DocumnetsApproversTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Document Approvers"
        subtitle="Create, view or edit document Approvers"
        columns={DocumentApproverColumns}
        FormComponent={DocumentApproversForm}
        query={allDocumentApprovers}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default DocumnetsApproversTable;